String.prototype.format = function (format) {

    let value = this;

    switch (format.toLowerCase()) {
        case 'c':
        case 'currency':
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            break;
        default:
            break;
    }

    return value
}
Number.prototype.format = function (format) {

    let value = this;

    switch (format.toLowerCase()) {
        case 'c':
        case 'currency':
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            break;
        default:
            break;
    }

    return value
}